export default __webpack_public_path__ + "static/media/searingcurse.f6bab35f.png";